import React from "react";
import "./Page5.css";
//-----------------------------------------
import { NavLink } from "react-router-dom";
import ArrowForwardIcon from "@material-ui/icons/ArrowForward";
//-----------------------------------------
import pagePhoto5 from "../images/pagePhoto5.png";
//-----------------------------------------

function Page5() {
  return (
    <div className="page5_container">
      <div className="page5_bangla">
        Order করার জন্য Phone Number দিয়ে "Verify" বাটন'এ Click করে OTP নিন। এখন
        আপনার দেওয়া Phone Number'এ SMS'এর মাধ্যমে একটি OTP আসবে। এই OTP'টি
        ব্যবহার করে “Sign In” করুন।
      </div>
      <div className="page5_english">
        To place the order Customer is required to “Sign In” using Phone Number
        and OTP. Enter your Mobile Phone Number and click on the “Verify” button
        to receive OTP by SMS. Now you can “Sign In” with the OTP received.
      </div>
      <div className="page5_photo_div">
        <img className="page5_photo" src={pagePhoto5} alt="PagePhoto5 Logo" />
      </div>
      {/*--------------go to page-6 (next page) starts-------------*/}
      <NavLink to="/page6" className="goto_next_page" exact>
        <span className="forwardIcon_text">Next</span>
        <ArrowForwardIcon className="next_page_icon" />
      </NavLink>
      {/*--------------go to page-6 (next page) ends-------------*/}
    </div>
  );
}

export default Page5;
